import React, { useContext } from 'react'
import { FormattedSKU, useSKU } from './useSKUs'
import useDiscountToken from './useDiscountToken'
import { ProductPackage } from '../types/productPageV2'

export interface PageProductProviderType {
  productPackage: ProductPackage
  children: React.ReactNode
}

type PageProductType = Partial<FormattedSKU | undefined>
export const PageProductContext = React.createContext<PageProductType>({})

export default function usePageProduct(): PageProductType {
  return useContext(PageProductContext)
}

export const PageProductProvider: React.FC<PageProductProviderType> = ({
  children,
  productPackage,
}) => {
  const discountCode = useDiscountToken()
  const { sort, items, planCode } = productPackage
  const pageSKU = useSKU(items, planCode, discountCode, sort)

  return (
    <PageProductContext.Provider value={pageSKU}>
      {children}
    </PageProductContext.Provider>
  )
}

PageProductProvider.displayName = 'PageProductProvider'
